import React from "react";
import { useParams } from "react-router-dom";
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import teamData from "../../data/consultation/Consultant.json"; // Import the JSON data


const iconMapping = {
    facebook: <FiFacebook />,
    twitter: <FiTwitter />,
    instagram: <FiInstagram />,
    linkedin: <FiLinkedin />
};

const ConsultantProfile = () => {
    const { id } = useParams(); // Get the id from the URL params
    const consultant = teamData.find((item) => item.id.toString() === id); // Match the consultant by id

    if (!consultant) {
        return <h2 className="text-center">Consultant Not Found</h2>;
    }

    return (
        <div className="container">
            <div className="profile-card">
                <img src={`./images/consultation/profile/${consultant.image}.jpg`} alt={consultant.name} />
                <h2>{consultant.name}</h2>
                <h4 className="theme-gradient">{consultant.designation}</h4>
                <p>{consultant.description}</p>
                <ul className="social-icons">
                    {consultant.socialNetwork.map((social, index) => (
                        <li key={index}>
                            <a href={social.url} target="_blank" rel="noopener noreferrer">
                                {iconMapping[social.icon]}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default ConsultantProfile;
